import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => (
  <div className="min-h-screen bg-cream flex items-center justify-center px-6">
    <div className="max-w-md w-full p-10 rounded-3xl bg-white/80 border border-rose/50 text-center">
      <XCircle className="w-14 h-14 text-mahogany mx-auto" />
      <h1 className="mt-5 font-serif-display text-3xl text-burgundy">Checkout cancelled</h1>
      <p className="mt-2 text-mahogany/80">No charge was made. You can choose a membership whenever you&apos;re ready.</p>
      <Link to="/membership" className="pill-btn mt-6 inline-flex">Back to Membership</Link>
    </div>
  </div>
);

export default PaymentCancel;
